<button type="button" class="bell-button" [matMenuTriggerFor]="menu" (menuOpened)="onOpened()"
  [attr.aria-label]="'header.notificationsOpen' | t">
  <mat-icon [matBadge]="badge" [matBadgeHidden]="unread === 0" matBadgeColor="warn" matBadgeSize="small"
    aria-hidden="false">{{ pushEnabled ? 'notifications_active' : 'notifications_none' }}</mat-icon>
</button>

<mat-menu #menu="matMenu" xPosition="before" class="notifications-menu">
  <div class="notif-header" (click)="$event.stopPropagation()">
    <span class="notif-title">{{ 'header.notificationsTitle' | t }}</span>
    @if (pushSupported) {
      <button type="button" class="notif-push-toggle" [class.on]="pushEnabled" [disabled]="pushBusy"
        (click)="togglePush.emit()">
        <mat-icon>{{ pushEnabled ? 'notifications_off' : 'notifications_active' }}</mat-icon>
        <span>{{ (pushEnabled ? 'header.disableNotifications' : 'header.enableNotifications') | t }}</span>
      </button>
    }
  </div>

  @if (deals.length === 0) {
    <p class="notif-empty">{{ 'header.notificationsEmpty' | t }}</p>
  }

  @for (deal of deals; track deal._id) {
    <button mat-menu-item class="notif-item" [class.is-new]="isNew(deal)" [class.is-expired]="!deal.available"
      (click)="openDeal(deal)">
      <div class="notif-row">
        @if (deal.pictureUrl) {
          <img class="notif-img" [src]="deal.pictureUrl" [appImgFallback]="deal.storedPictureUrl" alt="" width="52" height="52" loading="lazy" />
        }
        <div class="notif-text">
          <span class="notif-name">
            @if (deal.voteScore > 0) {
              <span class="notif-votes">🔥 {{ deal.voteScore }}°</span>
            }
            {{ deal.name }}
          </span>
          <span class="notif-detail">
            @if (isPromoCode(deal)) {
              <span class="notif-code">{{ 'header.notificationsPromoCode' | t }}</span>
            } @else if (currentPrice(deal)) {
              <span class="notif-price">{{ currentPrice(deal) | number: '1.0-2' }}€</span>
              @if (oldPrice(deal)) {
                <span class="notif-old-price">{{ oldPrice(deal) | number: '1.0-2' }}€</span>
              }
              @if (deal.percentageDiscount) {
                <span class="notif-percent">-{{ deal.percentageDiscount | number: '1.0-0' }}%</span>
              }
            }
            @if (deal.advertiserName || deal.advertiser) {
              <span class="notif-advertiser">{{ deal.advertiserName || deal.advertiser }}</span>
            }
          </span>
          <span class="notif-time">{{ timeAgo(deal) }}</span>
        </div>
        @if (isNew(deal)) {
          <span class="notif-dot" aria-hidden="true"></span>
        }
      </div>
    </button>
  }
</mat-menu>
